import { Box } from '@occc-app/design-system';
import { Chip, LinkChip, Table, TableBody, TableRow, Typography } from '@occc/ui-design-system';
import { pluralize } from '@occc-app/lib/strings';
import { TransactionViewTableCell } from '@occc-app/routes/Transactions/TransactionView/TransactionViewTableCell';

export const PointChangeViewSubItem = (props: {
  name: string;
  total: number;
  title?: string;
  link?: string;
}) => {
  const { name, title, link, total } = props;
  return (
    <Table
      sx={(theme) => ({
        borderCollapse: 'separate',
        borderSpacing: `0 ${theme.spacing(1)}`,
      })}
    >
      <TableBody>
        <TableRow hover={false}>
          <TransactionViewTableCell isLeftRadius isHighlighted noBottomBorder>
            <Box p={1}>
              {link ? (
                <LinkChip label={name} tooltip={title} href={link} />
              ) : (
                <Chip
                  title={title}
                  label={
                    <Typography component='span' variant='subtitle2'>
                      {name}
                    </Typography>
                  }
                  variant='outlined'
                />
              )}
            </Box>
          </TransactionViewTableCell>
          <TransactionViewTableCell align='right' isRightRadius isHighlighted noBottomBorder>
            <Box p={1}>
              <Typography color='textSecondary' variant='body2'>
                {`${total} ${pluralize(total, 'Point')}`}
              </Typography>
            </Box>
          </TransactionViewTableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
